import AOS from 'aos';
AOS.init( {
    offset: 300, // offset (in px) from the original trigger point
    duration: 1200, // values from 0 to 3000, with step 50ms
    easing: 'ease-in-out', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    // mirror: false,
});


import SimpleBar from 'simplebar';

// Инициализация SimpleBar с настройками
new SimpleBar(document.querySelector('.simplebar'), {
  // axis: 'x', // горизонтальный скролл
  // autoHide: false,
  forceVisible: 'x', // всегда показывать горизонтальный скроллбар
  // scrollbarMinSize: 50,
  scrollbar: 'simplebar-scrollbar',
  track: 'simplebar-track'
});
